import { SaleOfferLineProduct } from './sale-offer-line-product';
import { SaleOfferLineComplement } from './sale-offer-line-complement';
import { SaleOfferLineOther } from './sale-offer-line-other';

export const TYPE_PRODUCT = 1;
export const TYPE_COMPLEMENT = 2;
export const TYPE_OTHER = 3;

export class SaleOfferLine {
  constructor(
    public hash?: string,
    public type?: number,
    public position?: number,
    public saleOfferLineProduct?: SaleOfferLineProduct,
    public saleOfferLineComplement?: SaleOfferLineComplement,
    public saleOfferLineOther?: SaleOfferLineOther

  ) { }

  get isTypeProduct() {
    return this.type === TYPE_PRODUCT;
  }

  get isTypeComplement() {
    return this.type === TYPE_COMPLEMENT;
  }

  get isTypeOther() {
    return this.type === TYPE_OTHER;
  }

  clone() {
    return new SaleOfferLine(
      this.hash,
      this.type,
      this.position,
      this.saleOfferLineProduct,
      this.saleOfferLineComplement,
      this.saleOfferLineOther
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-offer-line.ts